module.exports = __webpack_public_path__ + "static/media/activity-dark.d4fae14f.svg";